import { isArsMasterReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { ITlfActionRenameVariantTemplate, TlfContextProps, UPDATE_TLF } from "./interface";
import { tlf_updateTlf } from "./tlf_updateTlf";

/**
 * Renames a variant definition without changing its patch selection or the current table.
 *
 * @param state - Current TLF data and saved baseline
 * @param action - Existing variant name and its requested replacement name
 * @returns Updated unsaved TLF, or unchanged state for an invalid rename
 */
export const tlf_renameVariantTemplate = (
  state: TlfContextProps,
  action: ITlfActionRenameVariantTemplate,
): TlfContextProps => {
  if (state.readOnly || !isArsMasterReadDto(state.tlfData)) return state;
  const current = state.tlfData;
  const newVariantName = action.newVariantName.trim();
  const currentTemplate = current.variantTemplates.find(
    (template) => template.name === action.variantName,
  );
  if (
    currentTemplate === undefined ||
    newVariantName.length === 0 ||
    current.variantTemplates.some(
      (template) =>
        template !== currentTemplate &&
        template.name.toLowerCase() === newVariantName.toLowerCase(),
    )
  ) {
    return state;
  }
  if (newVariantName === currentTemplate.name) return state;
  return tlf_updateTlf(state, {
    operation: UPDATE_TLF,
    tlfData: {
      variantTemplates: current.variantTemplates.map((template) =>
        template === currentTemplate ? { ...template, name: newVariantName } : template,
      ),
    },
    calledFrom: action.calledFrom,
  });
};
